var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCancelOrder = function SvgIconCancelOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M69.004 39.845 52 30l-17.004 9.844L52 49.69zM33 43.31V63l17 9.842V53.153zm21 29.531L71 63V43.311l-17 9.842z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 61,
    y: 63,
    rx: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C62828",
    d: "M71 80.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m0-8.56-2.121-2.122-1.061 1.06L69.939 73l-2.121 2.121 1.06 1.06L71 74.062l2.121 2.12 1.06-1.06L72.062 73l2.12-2.121-1.06-1.061z"
  })));
};
export default SvgIconCancelOrder;